<template>
  <div class="divBox">
    <el-card class="box-card">
      <el-form
        ref="formValidate"
        v-loading="fullscreenLoading"
        class="formValidate mt20"
        label-width="160px"
        v-model="formValidate"
        @submit.native.prevent
      >
        <el-row :gutter="24">
          <el-col>
            <el-form-item label="类型：" prop="is_type">
              <el-radio-group v-model="formValidate.is_type">
                <el-radio :label="1">图片</el-radio>
                <el-radio :label="2">视频</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col v-if="formValidate.is_type == 1">
            <el-form-item label="图片：" prop="images">
              <div class="acea-row">
                <div
                  v-for="(item, index) in formValidate.images"
                  :key="index"
                  class="pictrue"
                  draggable="false"
                  @dragstart="handleDragStart($event, item)"
                  @dragover.prevent="handleDragOver($event, item)"
                  @dragenter="handleDragEnter($event, item)"
                  @dragend="handleDragEnd($event, item)"
                >
                  <img :src="item">
                  <i
                    class="el-icon-error btndel"
                    @click="handleRemove(index)"
                  />
                </div>
                <div
                  v-if="formValidate.images.length < 10"
                  class="uploadCont"
                  title="750*750px"
                >
                  <div class="upLoadPicBox" @click="modalPicTap('2')">
                    <div class="upLoad">
                      <i class="el-icon-camera cameraIconfont" />
                    </div>
                  </div>
                </div>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="formValidate.is_type == 2">
            <el-form-item label="主图视频：" prop="video_link">
              <el-input
                v-model="videoLink"
                class="perW50"
                placeholder="请输入视频链接"
              />
              <input
                ref="refid"
                type="file"
                style="display:none"
                @change="zh_uploadFile_change"
              >
              <el-button
                type="primary"
                icon="ios-cloud-upload-outline"
                class="uploadVideo"
                @click="zh_uploadFile"
              >
                {{ videoLink ? "确认添加" : "上传视频" }}
              </el-button>
              <el-col :span="12">
                <el-progress
                  v-if="upload.videoIng"
                  :percentage="progress"
                  :text-inside="true"
                  :stroke-width="20"
                  style="margin-top: 10px;"
                />
              </el-col>
              <el-col :span="24">
                <div v-if="formValidate.video_link" class="iview-video-style">
                  <video
                    style="width:100%;height: 100%!important;border-radius: 10px;"
                    :src="formValidate.video_link"
                    controls="controls"
                  >
                    您的浏览器不支持 video 标签。
                  </video>
                  <div class="mark" />
                  <i class="el-icon-delete iconv" @click="delVideo" />
                </div>
              </el-col>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="选择话题：" prop="topic_id">
              <el-cascader
                v-model="formValidate.topic_id"
                class="selWidth"
                :options="categoryTopicList"
                :props="propsMer"
                filterable
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="发布商品类型：" prop="store_link_type">
              <el-radio-group v-model="formValidate.store_link_type">
                <el-radio :label="1">商品链接</el-radio>
                <el-radio :label="2">拼团链接</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="选择商品：" prop="product_image" v-if = 'formValidate.store_link_type == 1'>
              <div class="acea-row">
                <div
                  v-for="(item, index) in formValidate.product_image"
                  :key="index"
                  class="pictrue"
                  draggable="false"
                  @dragstart="handleDragStart($event, item)"
                  @dragover.prevent="handleDragOver($event, item)"
                  @dragenter="handleDragEnter($event, item)"
                  @dragend="handleDragEnd($event, item)"
                >
                  <img :src="item">
                  <i
                    class="el-icon-error btndel"
                    @click="handleProductRemove(index)"
                  />
                </div>
                <div
                  v-if="formValidate.images.length < 10"
                  class="uploadCont"
                  title="750*750px"
                >
                  <div class="upLoadPicBox" @click="add('2')">
                    <div class="upLoad">
                      <i class="el-icon-camera cameraIconfont" />
                    </div>
                  </div>
                </div>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if = 'formValidate.store_link_type == 2'>
            <el-form-item label="拼团商品链接：" prop="store_link_group">
              <el-input v-model="formValidate.store_link_group"  />
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if = 'formValidate.store_link_type == 1'>
            <el-form-item  label="外部商品链接：">
              <el-table
                :data="data"
                border
                size="small"
                style="width: 100%"
              >
                <el-table-column align="center" prop="store_link" label="外部商品链接" min-width="200">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.store_link" class="priceBox"/>
                  </template>
                </el-table-column>
                <el-table-column align="center" prop="is_skip" label="是否跳转" min-width="200">
                  <template slot-scope="scope">
                    <el-radio-group v-model="scope.row.is_skip">
                      <el-radio :label="0">否</el-radio>
                      <el-radio :label="1">是</el-radio>
                    </el-radio-group>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="操作" min-width="120">
                  <template slot-scope="scope">
                    <el-button type="text" class="submission" @click="delSpecs(scope.$index)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
            <el-form-item>
              <el-button size="small" type="primary" @click="onAdd">添加参数</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="标题：" prop="title">
              <el-input v-model="formValidate.title"  />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="内容：" prop="content">
              <el-input v-model="formValidate.content" type="textarea" placeholder="请输入" style="width: 90%" />
            </el-form-item>
          </el-col>
          <el-col v-if="formValidate.is_type == 1">
            <el-form-item label="图片说明：" prop="imageIntro">
              <div class="acea-row">
                <div
                  v-for="(item, index) in formValidate.imageIntro"
                  :key="index"
                  class="pictrue"
                  draggable="false"
                  @dragstart="handleDragStart($event, item)"
                  @dragover.prevent="handleDragOver($event, item)"
                  @dragenter="handleDragEnterIntro($event, item)"
                  @dragend="handleDragEnd($event, item)"
                >
                  <img :src="item">
                  <i
                    class="el-icon-error btndel"
                    @click="handleRemoveIntro(index)"
                  />
                </div>
                <div
                  v-if="formValidate.imageIntro.length < 10"
                  class="uploadCont"
                  title="750*750px"
                >
                  <div class="upLoadPicBox" @click="modalPicTap('3')">
                    <div class="upLoad">
                      <i class="el-icon-camera cameraIconfont" />
                    </div>
                  </div>
                </div>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="选择发布人：" prop="avatar">
              <div class="upLoadPicBox" @click="addUser()">
                <div v-if="formValidate.avatar" class="pictrue">
                  <img :src="formValidate.avatar">
                </div>
                <div v-else class="upLoad">
                  <i class="el-icon-camera cameraIconfont" />
                </div>
              </div>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="上架类型：" prop="push_status">
              <el-radio-group v-model="formValidate.push_status">
                <el-radio :label="1">直接上架</el-radio>
                <el-radio :label="2">定时上架</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="上架时间：" prop="push_time" v-if="formValidate.push_status == 2">
              <el-date-picker
                v-model='timeVal'
                format="yyyy-MM-dd HH:mm:ss"
                placeholder='选择发布日期时间'
                @change="onchangeTime"
                :picker-options="newOptions"
                type='datetime'
                class="selWidth"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item style="margin-top:30px;">
          <el-button :loading="loading" type="primary" class="submission" size="small" @click="handleSubmit()">提交</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <!--选择商品-->
    <goods-list ref="goodsList"  @getProduct="getProduct" />
    <!--选择用户-->
    <el-dialog v-if="visibleUserList" title="用户列表" :visible.sync="visibleUserList" width="1000px">
      <user-list ref="userList" v-if="visibleUserList" @getUser="getUser" />
    </el-dialog>
  </div>
</template>

<script>
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
import {
  categoryTopicListApi, communityDetailApi, saveCommunityDataApi
} from '@/api/community'
import { roterPre } from '@/settings'
import {productGetTempKeysApi} from "@/api/product";
import SettingMer from "@/libs/settingMer";
import {getToken} from "@/utils/auth";
import goodsList from './goodsList'
import userList from './userList'
const defaultObj = {
  is_type: 1,
  image: '',
  images: [],
  video_link: '',
  store_link: '',
  product_image: [],
  product_id: [],
  title: '',
  uid: '',
  avatar: '',
  content: '',
  topic_id: [],
  imageIntro: [],
  store_link_type: 1,
  store_link_group: '',
  push_status:1

}
export default {
  name: 'AssConfig',
  components: {goodsList,userList},
  data() {
    const url = SettingMer.https + '/upload/image/0/file?ueditor=1&token=' + getToken()
    return {
      roterPre: roterPre,
      fullscreenLoading: false,
      formValidate: Object.assign({}, defaultObj),
      loading: false,
      grid2: {
        xl: 10,
        lg: 12,
        md: 12,
        sm: 24,
        xs: 24
      },
      grid: {
        xl: 8,
        lg: 8,
        md: 12,
        sm: 24,
        xs: 24
      },
      storeTypeMap: {},
      videoLink: '',
      upload: {
        videoIng: false // 是否显示进度条；
      },
      progress: 0,
      myConfig: {
        autoHeightEnabled: false, // 编辑器不自动被内容撑高
        initialFrameHeight: 500, // 初始容器高度
        initialFrameWidth: '100%', // 初始容器
        enableAutoSave: false,
        UEDITOR_HOME_URL: '/UEditor/',
        'serverUrl': url,
        'imageUrl': url,
        'imageFieldName': 'file',
        imageUrlPrefix: '',
        'imageActionName': 'upfile',
        'imageMaxSize': 2048000,
        'imageAllowFiles': ['.png', '.jpg', '.jpeg', '.gif', '.bmp']
      },
      propsMer: { emitPath: false, multiple: true },
      categoryTopicList: [],
      data: [],
      dialogVisible: false,
      visibleUserList: false,
      moren: require('@/assets/images/f.png'),
      timeVal:'',
      newOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7
        },
        selectableRange:
          new Date().getHours() + ':' + (new Date().getMinutes() + 1) + ':00' + ' - 23:59:59',
      },
    }
  },
  mounted() {

    if (this.$route.params.id) {
      this.getCommunityData()
    }
    else
    {
      this.onAdd();
      this.formValidate.images = []
      this.formValidate.imageIntro = []
    }
    this.formValidate.product_image = []
    this.formValidate.product_id = []
    this.formValidate.uid = ''
    this.formValidate.avatar = ''
    this.getCategoryTopicList()
  },
  methods: {

    // 活动时间
    onchangeTime(e) {
      this.timeVal = e;
      this.formValidate.push_time = e ? this.moment(e).format('YYYY-MM-DD HH:mm:ss') : '';
    },
    getProduct(data) {
      this.formValidate.product_image.push(data.src)
      this.formValidate.product_id.push(data.id)
    },
    add() {
      this.$refs.goodsList.dialogVisible = true
    },
    getUser(data) {
      this.formValidate.avatar = data.avatar
      this.formValidate.uid = data.uid
      this.visibleUserList = false
    },
    addUser() {
      this.visibleUserList = true
    },
    handleProductRemove(i)
    {
      this.formValidate.product_image.splice(i, 1);
      this.formValidate.product_id.splice(i, 1);
    },
    onAdd() {
      let obj = { store_link: "" ,is_skip:0};
      this.data.push(obj);
    },
    // 删除
    delSpecs(idx) {
      this.data.splice(idx, 1);
    },
    // 删除视频；
    delVideo() {
      const that = this
      that.$set(that.formValidate, 'video_link', '')
      that.videoLink = '';
      that.progress = 0;
    },
    zh_uploadFile() {
      if (this.videoLink) {
        this.formValidate.video_link = this.videoLink
      } else {
        this.$refs.refid.click()
      }
    },
    zh_uploadFile_change(evfile) {

      const that = this
      that.progress = 10
      const suffix = evfile.target.files[0].name.substr(
        evfile.target.files[0].name.indexOf('.')
      )
      if (suffix !== '.mp4') {
        return that.$message.error('只能上传MP4文件')
      }
      productGetTempKeysApi().then(res => {
        that.$videoCloud
          .videoUpload({
            type: res.data.type,
            evfile: evfile,
            res: res,
            uploading(status, progress) {
              that.upload.videoIng = status
            }
          })
          .then(res => {
            that.formValidate.video_link = res.url || res.data.src
            that.videoLink = res.url || res.data.src
            that.$message.success('视频上传成功')
            that.progress = 100
          })
          .catch(res => {
            that.upload.videoIng = false
            that.$message.error(res.message)
          })
      })
    },
    // 点击图
    modalPicTap(tit, num, i) {
      const _this = this;
      const attr = [];
      this.$modalUpload(function(img) {
        if (tit === "1" && !num) {
          _this.formValidate.image = img[0];
        }
        if (tit === "2" && !num) {
          img.map(item => {
            _this.formValidate.images.push(item);
            if (_this.formValidate.images.length > 10) {
              _this.formValidate.images.length = 10;
            }
          });
        }
        if (tit === "3" && !num) {
          img.map(item => {
            _this.formValidate.imageIntro.push(item);
            if (_this.formValidate.imageIntro.length > 10) {
              _this.formValidate.imageIntro.length = 10;
            }
          });
        }
      }, tit);
    },
    // 移动
    handleDragStart(e, item) {
      this.dragging = item;
    },
    handleDragEnd(e, item) {
      this.dragging = null;
    },
    handleDragOver(e) {
      e.dataTransfer.dropEffect = "move";
    },
    handleDragEnter(e, item) {
      e.dataTransfer.effectAllowed = "move";
      if (item === this.dragging) {
        return;
      }
      const newItems = [...this.formValidate.images];
      const src = newItems.indexOf(this.dragging);
      const dst = newItems.indexOf(item);
      newItems.splice(dst, 0, ...newItems.splice(src, 1));
      this.formValidate.images = newItems;
    },
    handleRemove(i) {
      this.formValidate.images.splice(i, 1);
    },

    handleDragEnterIntro(e, item) {
      e.dataTransfer.effectAllowed = "move";
      if (item === this.dragging) {
        return;
      }
      const newItems = [...this.formValidate.imageIntro];
      const src = newItems.indexOf(this.dragging);
      const dst = newItems.indexOf(item);
      newItems.splice(dst, 0, ...newItems.splice(src, 1));
      this.formValidate.imageIntro = newItems;
    },
    handleRemoveIntro(i) {
      this.formValidate.imageIntro.splice(i, 1);
    },
    // 商户分类；
    getCategoryTopicList() {
      categoryTopicListApi()
        .then(res => {
          this.categoryTopicList = res.data
        })
        .catch(res => {
          this.$message.error(res.message)
        })
    },
    // 获取数据
    getCommunityData() {
      this.fullscreenLoading = true
      communityDetailApi(this.$route.params.id)
        .then(res => {
          this.fullscreenLoading = false
          this.loading = false
          if (res.data) {
            this.formValidate.is_type = res.data.is_type
            this.formValidate.title = res.data.title
            this.formValidate.content = res.data.content
            this.formValidate.uid = res.data.uid
            this.formValidate.avatar = res.data.author.avatar
            this.formValidate.topic_id = res.data.topic_id
            this.formValidate.store_link_type = res.data.store_link_type
            this.formValidate.push_status = res.data.push_status
            this.formValidate.push_time = res.data.push_time
            this.timeVal = res.data.push_time
            console.log( this.formValidate.topic_id)
            if(!this.formValidate.avatar)
            {
              this.formValidate.avatar = this.moren
            }
            if(res.data.is_type == 1)
            {
              this.formValidate.images = res.data.image
              this.formValidate.imageIntro = res.data.imageIntro
            }
            else
            {
              this.formValidate.image = res.data.image
              this.formValidate.imageIntro = []
            }
            this.formValidate.video_link = res.data.video_link
            this.videoLink = res.data.video_link
            var store_content = res.data.store_content;
            if(store_content)
            {
              if(this.formValidate.store_link_type == 2 && store_content[0])
              {
                this.formValidate.store_link_group = store_content[0].store_link;
              }
              else
              {
                store_content.forEach((item)=>
                {
                  this.data.push({store_link: item.store_link,'is_skip':item.is_skip})
                })
              }

            }
            var relevance = res.data.relevance;
            if(relevance)
            {
              relevance.forEach((ri)=>
              {
                if(ri.type == 'community_product')
                {
                  this.formValidate.product_image.push(ri.spu.image)
                  this.formValidate.product_id.push(ri.spu.product_id)
                }
              })
            }

          }
        })
        .catch(res => {
          this.fullscreenLoading = false
          this.$message.error(res.message)
        })
    },
    // 获取
    getStoreTypeMap() {
      getStoreTypeApi()
        .then(res => {
          this.storeTypeMap = res.data
        })
        .catch(res => {
          this.$message.error(res.message)
        })
    },
    // 提交
    handleSubmit() {
      if (this.formValidate.is_type === 1) {
        if (!this.formValidate.images) {
          this.$message.error('请选择图片')
          return false
        }
      }
      if (this.formValidate.is_type === 2) {
        if (!this.formValidate.video_link) {
          this.$message.error('请上传视频')
          return false
        }
      }
      if (!this.formValidate.title) {
        this.$message.error('请填写标题')
        return false
      }
      // if (!this.formValidate.content) {
      //     this.$message.error('请填写内容')
      //     return false
      // }
      if (this.formValidate.is_type === 2) {
        this.formValidate.imageIntro = [];
      }
      // if (!this.formValidate.avatar) {
      //   this.$message.error('请选择发布人')
      //   return false
      // }
      this.formValidate.store_link = this.data;
      this.formValidate.community_id = this.$route.params.id;
      saveCommunityDataApi(this.formValidate)
        .then(res => {
          this.fullscreenLoading = false
          this.$message.success(res.message)
          this.$router.push({ path: this.roterPre + '/community/list' })
          this.loading = false
        })
        .catch(res => {
          this.fullscreenLoading = false
          this.loading = false
          this.$message.error(res.message)
        })
    }
  }
}
</script>
<style scoped lang="scss">
.label_tip{
  display: inline-block;
  margin-left: 20px;
  color: #C0C4CC;
}
.selWidth {
  width: 100%;
}
.selWidthd {
  width: 300px;
}
.dialog-scustom,.addDia{
  min-width: 400px;
  height: 900px;
  .el-dialog{
    width: 400px;
  }
  h3{
    color: #333;
    font-size: 16px;
    text-align: center;
    font-weight: bold;
    margin: 0;
  }
}
.pictrue {
  width: 60px;
  height: 60px;
  border: 1px dotted rgba(0, 0, 0, 0.1);
  margin-right: 10px;
  position: relative;
  cursor: pointer;
  img {
    width: 100%;
    height: 100%;
  }
}
.agreement{
  width: 350px;
  margin: 0 auto;
  box-shadow: 1px 5px 5px 2px rgba(0,0,0,.2);
  padding: 26px;
  border-radius: 15px;
  .content{
    height: 600px;
    overflow-y:scroll;
    /deep/ p{
      font-size: 13px;
      line-height: 22px;
    }
  }
  /deep/ img{
    max-width: 100%;
  }
  p{
    text-align: justify;
  }
}
/*css主要部分的样式*/
/*定义滚动条宽高及背景，宽高分别对应横竖滚动条的尺寸*/
::-webkit-scrollbar {
  width: 10px; /*对垂直流动条有效*/
  height: 10px; /*对水平流动条有效*/
}
/*定义滚动条的轨道颜色、内阴影及圆角*/
::-webkit-scrollbar-track{
  /*-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);*/
  background-color: transparent;
  border-radius: 3px;
}
.iview-video-style {
  width: 40%;
  height: 180px;
  border-radius: 10px;
  background-color: #707070;
  margin-top: 10px;
  position: relative;
  overflow: hidden;
}
.iconv {
  color: #fff;
  line-height: 180px;
  display: inherit;
  font-size: 26px;
  position: absolute;
  top: -74px;
  left: 50%;
  margin-left: -25px;
}
.iview-video-style .mark {
  position: absolute;
  width: 100%;
  height: 30px;
  top: 0;
  background-color: rgba(0, 0, 0, 0.5);
  text-align: center;
}
.uploadVideo {
  margin-left: 10px;
}
.perW50 {
  width: 50%;
}
.submission {
  margin-left: 10px;
}
.btndel {
  position: absolute;
  z-index: 1;
  width: 20px !important;
  height: 20px !important;
  left: 46px;
  top: -4px;
}

</style>
